import { render } from "./TokenLibrary.vue?vue&type=template&id=16b1c1df&scoped=true&ts=true"
import script from "./TokenLibrary.vue?vue&type=script&lang=ts"
export * from "./TokenLibrary.vue?vue&type=script&lang=ts"

import "./TokenLibrary.vue?vue&type=style&index=0&id=16b1c1df&scoped=true&lang=css"
import "./TokenLibrary.vue?vue&type=style&index=1&id=16b1c1df&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b1c1df"]])

export default __exports__